export default {
  en: {
    title: 'Already practising in our Telegram bot?',
    body: 'Connect it, and your progress, word lists and subscription will be here too.',
    yes: 'Yes, connect Telegram',
    no: 'No, I’m new here',
  },
  ru: {
    // Неразрывный дефис (U+2011): иначе строка рвалась на «Telegram-/боте».
    title: 'Уже занимаешься в нашем Telegram‑боте?',
    body: 'Подключи его — и здесь будут твой прогресс, словари и подписка.',
    yes: 'Да, подключить Telegram',
    no: 'Нет, я здесь впервые',
  },
};
